import { PrintReceiptComponent } from "@/app/infrastructures/dependencies/modules/PrintReceiptComponent";
import store from "@/store";
import { container } from "tsyringe";
import {
  getModule,
  Module,
  VuexModule,
  Action,
  Mutation
} from "vuex-module-decorators";
import { ListInvoiceApiRequest } from "@/data/payload/api/PrintReceiptRequest";
import { PrintReceiptPresenter } from "../presenters/PrintReceiptPresenter";
import {
  CreateInvoiceApiRequest,
  CreateInvoiceDetailBillApiRequest,
  ListBookingHistoryDetailApiRequest,
  SettlementInvoiceRequest,
  DraftPreviewForUpdateRequest,
  UpdateInvoiceRequest,
  ActivityRequest
} from "@/data/payload/api/PrintReceiptApiRequest";
import {
  PRINT_RECEIPT_KEY,
  printReceiptChannel,
  Receiver,
  SendInvoiceResponseData,
  AddDraftResponseData,
  GetPreviewResponseData,
  SttHistorySuccessBooking,
  SuccessInvoiceData,
  Invoice
} from "@/domain/entities/PrintReceipt";
import {
  getDataSessionStorageParsed,
  storeDatatoSessionStorageParsed
} from "@/app/infrastructures/misc/LocalStorage";
import { MainAppController } from "./MainAppController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { AddDraftReceiptApiRequest } from "@/data/payload/api/AddDraftReceiptApiRequest";
import { createI18n } from 'vue-i18n';
import { AccountController } from './AccountController';
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import formatPrice from '@/app/infrastructures/misc/common-library/v2/FormatPrice';
PrintReceiptComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "PrintReceipt"
})
class PrintReceiptStore extends VuexModule {
  public getPreviewSuccessData = new GetPreviewResponseData();
  public addDraftSuccessData = new AddDraftResponseData();

  @Action
  async create(payload: CreateInvoiceApiRequest) {
    const repository = container.resolve(PrintReceiptPresenter);
    return repository.create(payload);
  }

  @Action
  async createInvoice(payload: CreateInvoiceDetailBillApiRequest) {
    const repository = container.resolve(PrintReceiptPresenter);
    return repository.createInvoice(payload);
  }

  @Action
  async getDetailInvoice(id: number) {
    const repository = container.resolve(PrintReceiptPresenter);
    return repository.getDetailInvoice(id);
  }

  @Action
  async getBookingHistoryDetail(params: ListBookingHistoryDetailApiRequest) {
    const repository = container.resolve(PrintReceiptPresenter);
    return repository.getBookingHistoryDetail(params);
  }

  // open modal preview invoice
  visiblePreviewInvoice = false;
  @Mutation
  setVisiblePreviewInvoice(value: boolean) {
    this.visiblePreviewInvoice = value;
  }

  // open modal preview invoice
  visibleToastHistorySuccessBooking = false;
  @Mutation
  setVisibleToastHistorySuccessBooking(value: boolean) {
    this.visibleToastHistorySuccessBooking = value;
  }

  // [START] BROADCAST CHANNEL: SYNC MULTI TAB
  // list stt success booking in localstorage
  listSttSuccessBooking: string[] =
    getDataSessionStorageParsed(PRINT_RECEIPT_KEY.LIST_STT_SUCCESS_BOOKING) || [];

  @Mutation
  SET_LIST_STT_SUCCESS_BOOKING(value: string[]) {
    this.listSttSuccessBooking = value;

    storeDatatoSessionStorageParsed(PRINT_RECEIPT_KEY.LIST_STT_SUCCESS_BOOKING, value);
  }

  @Action
  addListSttSuccessBooking(value: string) {
    const updated = [...new Set([value, ...this.listSttSuccessBooking])].filter(
      Boolean
    );

    this.context.commit("SET_LIST_STT_SUCCESS_BOOKING", updated);

    /*printReceiptChannel.post({
      type: "SYNC_LIST",
      payload: updated
    });*/
  }

  @Action
  resetListSttSuccessBooking() {
    const updated: string[] = [];

    this.context.commit("SET_LIST_STT_SUCCESS_BOOKING", updated);

    /*printReceiptChannel.post({
      type: "SYNC_LIST",
      payload: updated
    });*/
  }

  // last date stt success booking in localstorage
  lastDateSttSuccessBooking: string =
    getDataSessionStorageParsed(
      PRINT_RECEIPT_KEY.LAST_DATE_STT_SUCCESS_BOOKING
    ) || "";

  @Mutation
  SET_LAST_DATE_STT_SUCCESS_BOOKING(value: string) {
    this.lastDateSttSuccessBooking = value;

    storeDatatoSessionStorageParsed(
      PRINT_RECEIPT_KEY.LAST_DATE_STT_SUCCESS_BOOKING,
      value
    );
  }

  @Action
  setLastDateSttSuccessBooking(value = "") {
    this.context.commit("SET_LAST_DATE_STT_SUCCESS_BOOKING", value);

    /*printReceiptChannel.post({
      type: "SYNC_LAST_DATE",
      payload: value
    });*/
  }
  // [END] BROADCAST CHANNEL: SYNC MULTI TAB

  // create new invoice from success booking
  processInvoiceFromSuccessBooking = false;
  @Mutation
  setProcessInvoiceFromSuccessBooking(value = false) {
    this.processInvoiceFromSuccessBooking = value;
  }

  isSuccessCreateInvoice = false;
  @Mutation
  setSuccessCreateInvoice(value = false) {
    this.isSuccessCreateInvoice = value;
  }

  successCreateInvoiceData = new SuccessInvoiceData();
  @Mutation
  setSuccessCreateInvoiceData(value = new SuccessInvoiceData()) {
    this.successCreateInvoiceData = value;
  }

  invoiceDetailData = new Invoice();
  @Mutation
  setInvoiceDetailData(value = new Invoice()) {
    this.invoiceDetailData = value;
  }

  @Mutation
  resetCreateInvoiceFromSuccessBooking() {
    this.isSuccessCreateInvoice = false;
    this.processInvoiceFromSuccessBooking = false;
    this.selectedSttHistorySuccessBooking = [];
  }

  // selected stt history success booking
  selectedSttHistorySuccessBooking: SttHistorySuccessBooking[] = [];
  @Mutation
  setSelectedSttHistorySuccessBooking(value: SttHistorySuccessBooking[]) {
    this.selectedSttHistorySuccessBooking = value;
  }

  public invoiceSuccessData = new SendInvoiceResponseData();
  public isShowModalSuccess = false;

  @Action
  public sendInvoice({
    id,
    dataRequest,
    isShowModalSuccess = false
  }: {
    id: number;
    dataRequest: FormData;
    isShowModalSuccess?: boolean;
  }) {
    MainAppController.showLoading();

    const presenter = container.resolve(PrintReceiptPresenter);
    presenter
      .sendInvoice({ id, dataRequest })
      .then((res) => {
        this.setInvoiceSuccessData(res);

        if (isShowModalSuccess) this.setIsShowModalSuccess(true);

        return res;
      })
      .catch((error: any) => {
        console.log(error, "ini error");
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Gagal mendapatkan data!", () => {
            MainAppController.closeErrorMessage();
          })
        );
        return {
          data: "",
          success: false
        };
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  @Mutation
  public setInvoiceSuccessData(val: SendInvoiceResponseData) {
    this.invoiceSuccessData = val;
  }

  @Mutation
  public setIsShowModalSuccess(val: boolean) {
    this.isShowModalSuccess = val;
  }

  @Action
  public getListInvoices(params: ListInvoiceApiRequest) {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.getListInvoices(params);
  }

  @Action
  public async settlementInvoice(data: {
    id: number;
    payload: SettlementInvoiceRequest;
  }) {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.settlementInvoice(data.id, data.payload);
  }

  @Action
  public async getPaymentDetailInvoice(id: number) {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.paymentDetailInvoice(id);
  }

  @Action
  public async processSendInvoice(params: {
    validReceivers: Receiver[];
    invoiceId: number;
    invoiceNo: string;
    pdf: any;
    png: any;
    pdfStruk: any;
    isShowModalSuccess?: boolean;
  }) {
    const {
      validReceivers,
      invoiceId,
      invoiceNo,
      pdf,
      pdfStruk,
      png,
      isShowModalSuccess
    } = params;

    try {
      // Handle WhatsApp downloads (client side)
      const waReceivers = validReceivers.filter((r) => r.via === "whatsapp");

      const formatPhone62 = (phone: string): string => {
        // Remove all non-numeric characters
        let cleaned = phone.replace(/\D/g, "");

        // If starts with 0, replace with 62
        if (cleaned.startsWith("0")) {
          cleaned = "62" + cleaned.substring(1);
        }

        return cleaned;
      };

      const i18nInstance = createI18n({
        legacy: false,
        locale: AccountController.accountData.account_type_detail.countryCode.toLowerCase(),
        fallbackLocale: "id",
        globalInjection: false,
        messages: {
          en,
          id,
          my
        }
      });
      const t = i18nInstance.global.t;

      for (const waItem of waReceivers) {
        const cleanPhone = formatPhone62(waItem.value);
        const message = encodeURIComponent(
          t("tagihan.whatsappMessage", {
            name: this.invoiceDetailData.header.billedToName,
            invoiceNo: invoiceNo,
            totalStt: this.invoiceDetailData.header.totalStt,
            totalAmount: formatPrice(
              this.invoiceDetailData.header.totalAmount,
              "",
              AccountController.accountData.accountCurrency
            )
          })
        );
        const link = `https://wa.me/${cleanPhone}?text=${message}`;
        window.open(link, "_blank");
      }

      // Send invoice via API (all channels)
      const formData = new FormData();

      validReceivers.forEach((item, idx) => {
        formData.append(`send_to[${idx}][via]`, item.via);

        if (item.via === "email") {
          formData.append(`send_to[${idx}][email]`, item.value);
        } else {
          formData.append(`send_to[${idx}][phone]`, formatPhone62(item.value));
        }

        formData.append(`send_to[${idx}][format]`, item.format);
      });

      // TODO: Append generated files here
      // const requiredFormats = [...new Set(validReceivers.map((r) => r.format))];
      // map the required formats and then append the generated files accordingly, below is an "example"
      if (pdf) {
        formData.append("file_pdf_a4", pdf);
      }
      if (png) {
        formData.append("file_png_a4", png);
      }
      if (pdfStruk) {
        formData.append("file_pdf_struk", pdfStruk);
      }

      // Call API
      await this.sendInvoice({
        id: invoiceId || 0,
        dataRequest: formData,
        isShowModalSuccess
      });
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, "Gagal Mengirim Tagihan", () =>
          this.processSendInvoice(params)
        )
      );
    }
  }

  @Action
  public addDraft(payload: AddDraftReceiptApiRequest) {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.addDraft(payload);
  }

  @Mutation
  public setAddDraftSuccessData(val: AddDraftResponseData) {
    this.addDraftSuccessData = val;
  }

  @Action
  public getPreview() {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.getPreview();
  }

  @Mutation
  public setGetPreviewSuccessData(val: GetPreviewResponseData) {
    this.getPreviewSuccessData = val;
  }

  @Action
  public async getInvoiceForUpdate(id: number) {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.getInvoiceForUpdate(id);
  }

  @Action
  public async draftPreviewForUpdate(data: {
    id: number;
    payload: DraftPreviewForUpdateRequest;
  }) {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.draftPreviewForUpdate(data.id, data.payload);
  }

  @Action
  public async updateInvoice(data: {
    id: number;
    payload: UpdateInvoiceRequest;
  }) {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.updateInvoice(data.id, data.payload);
  }

  @Action
  public async activity(data: { id: number; payload: ActivityRequest }) {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.activity(data.id, data.payload);
  }

  @Action
  public async clearDraftItems() {
    const presenter = container.resolve(PrintReceiptPresenter);
    return presenter.clearDraftItems();
  }
}

export const PrintReceiptController = getModule(PrintReceiptStore);
